import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import Loading from '../common/Loading'
import BookingItem from './BookingItem'
import BookingCancelModal from '../modals/BookingCancelModal'
import { BOOKING, BookingContext } from './BookingContext'
import Arrow from '../common/icons/Arrow'
import { fetchBookingsAction } from '../helpers/bookingHelper'

const _renderBookings = (bookings) => {
  const { state } = useContext(BookingContext)
  if (!bookings || bookings.length < 1) {
    if (state.isLoading)
      return

    return <li className="item row">
      <h3 className="padded">You have no past or present bookings</h3>
    </li>
  }

  return bookings.map((booking, index) => (
    <BookingItem key={index} booking={booking} />
  ))
}

const BookingsList = ({ bookings }) => {
  const { state, dispatch } = useContext(BookingContext)

  const _handlePageClick = (event) => {
    fetchBookingsAction(dispatch, event.selected + 1)
  }

  const PrevButton = () => <span><Arrow /></span>
  const NextButton = () => <span><Arrow /></span>

  const _renderPagination = () => {
    if (!state.meta || (state.meta.total_pages < 2))
      return

    // let currentOffset = state.meta.current_page * state.meta.per_page

    return (
      <div className="pagination-container">
        <ReactPaginate
          previousLabel={PrevButton()}
          nextLabel={NextButton()}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={state.meta.total_pages}
          forcePage={state.meta.current_page - 1}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={_handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
        {/* <small className="showing">{currentOffset}-{currentOffset + bookings.length} of {state.meta.total_count}</small> */}
      </div>
    )
  }

  return (
    <div className="left column">
      <ul className={`interactive rows scrollable list ${state.meta ? "pagination-active" : ''}`}>
        {_renderBookings(bookings)}
      </ul>
      {_renderPagination()}
      {state.isLoading && !state.cancellation && <Loading loadingIconClassName="builder relative"/>}
      { state.cancellation && <BookingCancelModal open={true} /> }
    </div>
  )
}

BookingsList.propTypes = {
  bookings: PropTypes.array,
}

export default BookingsList
